<h2 mat-dialog-title>
    Cliente: {{data.dadosCliente.cliente}} 
</h2>

<div id="gerador-ordem" class="page-layout simple inner-scroll">
    <div class="center">
        <div fxLayout="row wrap">            
            <p><b>Motivo:</b> {{data.dadosCliente.motivo_recusa}}</p>
            <p><b>Total Boletado Líquido:</b> R$ {{data.dadosCliente.valor_financeiro_liquido | number : '1.2-2'}}</p>
        </div>
        <div fxLayout="row wrap">
            <mat-card style="width: 49%; border: solid 1px #ccc; margin-bottom: 20px; float: left;"> 
                <mat-card-header style="margin-bottom: 10px">
                    <mat-card-title>Concetração por ativo</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <table mat-table [dataSource]="rows" style="width: 100%;">
                        <ng-container matColumnDef="ativo">
                            <th mat-header-cell *matHeaderCellDef>Ativo</th>
                            <td mat-cell *matCellDef="let element"> {{element.ativo}} </td>
                            <td mat-footer-cell *matFooterCellDef> <b>Total</b> </td>
                        </ng-container>
        
                        <ng-container matColumnDef="quantidade">
                            <th mat-header-cell *matHeaderCellDef>Qtd</th>
                            <td mat-cell *matCellDef="let element"> {{element.quantidade | number : '1.0-0'}} </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="percentual">
                            <th mat-header-cell *matHeaderCellDef>Concentração</th>
                            <td mat-cell *matCellDef="let element"> {{ percentualFinanceiro(element) | number : '1.2-2'}} % </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
        
                        <ng-container matColumnDef="vlr_financeiro">
                            <th mat-header-cell *matHeaderCellDef>Financeiro</th>
                            <td mat-cell *matCellDef="let element"> R$ {{element.vlr_financeiro | number : '1.2-2'}} </td>
                            <td mat-footer-cell *matFooterCellDef> <b>R$ {{getTotalBruto() | number : '1.2-2'}} </b></td>
                        </ng-container>  
                        
                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
                        <tr mat-footer-row *matFooterRowDef="columnsToDisplay; sticky: true"></tr>
                    </table>
                </mat-card-content>            
            </mat-card>

            <mat-card style="width: 49%; border: solid 1px #ccc; margin-bottom: 20px; float: right;margin-left: 2%;"> 
                <mat-card-header style="margin-bottom: 10px">
                    <mat-card-title>Concetração por setor</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <table 
                        mat-table 
                        [dataSource]="rowsSetor" 
                        style="width: 100%;"
                    >
                        <ng-container matColumnDef="setor">
                            <th mat-header-cell *matHeaderCellDef>Setor</th>
                            <td mat-cell *matCellDef="let element"> {{element.setor}} </td>
                            <td mat-footer-cell *matFooterCellDef> <b>Total</b> </td>
                        </ng-container>

                        <ng-container matColumnDef="percentual">
                            <th mat-header-cell *matHeaderCellDef>Concentração</th>
                            <td mat-cell *matCellDef="let element"> {{ percentualFinanceiro(element) | number : '1.2-2'}} % </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
        
                        <ng-container matColumnDef="vlr_financeiro">
                            <th mat-header-cell *matHeaderCellDef>Financeiro</th>
                            <td mat-cell *matCellDef="let element"> R$ {{element.vlr_financeiro | number : '1.2-2'}} </td>
                            <td mat-footer-cell *matFooterCellDef> <b>R$ {{getTotalBrutoSetor() | number : '1.2-2'}} </b></td>
                        </ng-container>  
                        
                        <tr mat-header-row *matHeaderRowDef="columnsToDisplaySetor; sticky: true"></tr>
                        <tr mat-row *matRowDef="let rowsSetor; columns: columnsToDisplaySetor;"></tr>
                        <tr mat-footer-row *matFooterRowDef="columnsToDisplaySetor; sticky: true"></tr>
                    </table>
                </mat-card-content>            
            </mat-card>
        </div>
        
        <div fxLayout="row wrap">
            <mat-card style="width: 100%; border: solid 1px #ccc;">
                <mat-card-header style="margin-bottom: 10px">
                    <mat-card-title>Adicionar Ativo</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="boletaForm" style="width: 100%;">
                        <div formArrayName="ativos">
                            <div 
                                fxLayout="row" 
                                fxLayoutAlign="space-between" 
                                *ngFor="let item of ativos.controls; let pointIndex=index" 
                                [formGroupName]="pointIndex"
                            >
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="43">
                                    <mat-label>Ativo</mat-label>
                                    <input
                                        matInput
                                        placeholder="Ticker do ativo"
                                        aria-label="Ativo"
                                        formControlName="ativo"
                                        name="ativo"
                                        required
                                        minlength="5"
                                        style="text-transform: uppercase"
                                    >
                                </mat-form-field>

                                <mat-form-field appearance="outline" floatLabel="always" fxFlex="43">
                                    <mat-label>Qtd.</mat-label>
                                    <input
                                        matInput         
                                        type="number"                               
                                        aria-label="Quantidade"
                                        formControlName="qtd"
                                        name="qtd"
                                        readonly                                  
                                        minlength="10"
                                        style="text-transform: uppercase"
                                    >
                                </mat-form-field>
            
                                <button 
                                    fxFlex="3"
                                    mat-icon-button  
                                    tabindex="2" 
                                    (click)="removeAtivo(pointIndex)"
                                    color="warn"
                                    style="height: 65px;"
                                > 
                                    <mat-icon aria-label="Adicionar Novo Ativo">remove_circle_outline</mat-icon>                       
                                </button>    
                                <br />
                            </div>
                        </div>
            
                        <div fxLayout="row" fxLayoutAlign="space-between" >
                            <button 
                                mat-raised-button 
                                color="primary" 
                                (click)="addAtivo()"                                
                                style="height: 40px; margin-top: 3px; width: 35%; text-align: center;margin: 0 auto;"
                            >
                                <mat-icon aria-label="Adicionar Ativo">add_circle_outline</mat-icon>
                                Adicionar Ativo(s)
                            </button>
                        </div>           
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<div class="buttons-actions" mat-dialog-actions >
    <button 
        mat-raised-button
        color="warn"
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    
    <button 
        mat-raised-button  
        color="accent"         
        (click)="salvar()" 
        tabindex="-1"
    >
        Gerar Ordens
    </button>
</div>